module.exports = __webpack_public_path__ + "static/media/introVideo.54e7a6b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowSix/introVideo.jpg
// module id = 94
// module chunks = 0